<template>
  <div>
    <div class="row">
      <div class="col-lg-7">
        <h2>Долговременное сотрудничество и количество подключенных услуг напрямую влияет на Ваш статус по Программе Привилегий</h2>

        <div class="row statuses">
          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3">
            <div
              class="status shadow-hover"
              :class="{ current: isCurrentStatus($getConst('LOYALTY_STATUS_BRONZE')) }"
            >
              <router-link :to="{ name: 'SpecialOffer' }">
                <img
                  src="../../img/status_bronze.png"
                  alt="Bronze"
                >
                <p class="name">
                  Bronze
                </p>
                <p>
                  Ежемесячный бюджет:<br>
                  до 40 000 рублей.
                </p>
                <img
                  v-if="isCurrentStatus($getConst('LOYALTY_STATUS_BRONZE'))"
                  src="../../img/privilege-program/status-current.png"
                  alt="Current status"
                  class="status-current-img"
                >
              </router-link>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3">
            <div
              class="status shadow-hover"
              :class="{ current: isCurrentStatus($getConst('LOYALTY_STATUS_SILVER')) }"
            >
              <router-link :to="{ name: 'SpecialOffer' }">
                <img
                  src="../../img/status_silver.png"
                  alt="Silver"
                >
                <p class="name">
                  Silver
                </p>
                <p>
                  Ежемесячный бюджет:<br>
                  до 40 000 - 80 000 рублей.
                </p>
                <p class="text-bold">
                  Сотрудничество от 4 месяцев.
                </p>
                <img
                  v-if="isCurrentStatus($getConst('LOYALTY_STATUS_SILVER'))"
                  src="../../img/privilege-program/status-current.png"
                  alt="Current status"
                  class="status-current-img"
                >
              </router-link>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3">
            <div
              class="status shadow-hover"
              :class="{ current: isCurrentStatus($getConst('LOYALTY_STATUS_GOLD')) }"
            >
              <router-link :to="{ name: 'SpecialOffer' }">
                <img
                  src="../../img/status_gold.png"
                  alt="Gold"
                >
                <p class="name">
                  Gold
                </p>
                <p>
                  Ежемесячный бюджет:<br>
                  до 80 000 - 120 000 рублей.
                </p>
                <p class="text-bold">
                  Сотрудничество от 8 месяцев.
                </p>
                <img
                  v-if="isCurrentStatus($getConst('LOYALTY_STATUS_GOLD'))"
                  src="../../img/privilege-program/status-current.png"
                  alt="Current status"
                  class="status-current-img"
                >
              </router-link>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3">
            <div
              class="status shadow-hover"
              :class="{ current: isCurrentStatus($getConst('LOYALTY_STATUS_PLATINUM')) }"
            >
              <router-link :to="{ name: 'SpecialOffer' }">
                <img
                  src="../../img/status_platinum.png"
                  alt="Platinum"
                >
                <p class="name">
                  Platinum
                </p>
                <p>
                  Ежемесячный бюджет:<br>
                  от 120 000 рублей.
                </p>
                <p class="text-bold">
                  Сотрудничество от 12 месяцев.
                </p>
                <img
                  v-if="isCurrentStatus($getConst('LOYALTY_STATUS_PLATINUM'))"
                  src="../../img/privilege-program/status-current.png"
                  alt="Current status"
                  class="status-current-img"
                >
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-5 text-center">
        <img
          src="../../img/privilege-program/illustration.png"
          alt="privilege program"
          class="margin-bottom illustration hidden-xs hidden-sm hidden-md"
        >
        <br>
        <router-link
          tag="button"
          class="btn btn-warning"
          :to="{ name: 'PrivilegeProgramRules' }"
        >
          Правила программы
        </router-link>
      </div>
    </div>
    <h2>Как улучшить свой статус?</h2>
    <services-not-connected next-step />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ServicesNotConnected from '../components/ServicesNotConnected'

export default {
  name: 'PrivilegeProgram',
  components: { ServicesNotConnected },
  computed: {
    ...mapGetters({
      isCurrentStatus: 'seo/client/info/isCurrentStatus'
    })
  }
}
</script>

<style lang="scss" scoped>
@import "./resources/css/_variables.scss";

.statuses {
  display: flex;
  flex-wrap: wrap;
}

.statuses > div {
  padding: 15px;
}

.statuses .status {
  height: 100%;
  padding: 20px;
  background-color: white;
  border-radius: $borderRadiusLarge;
  position: relative;
}

.statuses .status:hover {
  cursor: pointer;
}

.statuses .status.current {
  border: 2px solid $textSuccessColor;
}

.statuses .status img {
  margin-bottom: 15px;
}

.statuses .status a {
  color: inherit;
  text-decoration: none;
}

.statuses .status .name {
  font-size: 1.2em;
  font-weight: bold;
}

.statuses .status .status-current-img {
  position: absolute;
  top: 20px;
  right: 20px;
}

.illustration {
  margin-top: 20px;
}
</style>
